// extracted by mini-css-extract-plugin
export default {"fieldMarginWrapper":"FieldStyler_fieldMarginWrapper__rCS3+","customNumberInputWrapper":"FieldStyler_customNumberInputWrapper__cwScI","marginInput":"FieldStyler_marginInput__mKyq0"};